import type { UseCustomOptions } from "./useCustom.type";
import type { ApiError } from "@/services/api";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useCustom = <Data = unknown>(
  endPoint: string,
  options?: UseCustomOptions<Data>
) => {
  const {
    method = "get",
    params = {},
    neverStale = false,
    ...queryOptions
  } = options ?? {};

  return useQuery<Data, ApiError>({
    queryKey: [endPoint, params],
    queryFn: async () => {
      const response = await client.axios[method](`/${endPoint}`, { params });
      return response.data;
    },
    staleTime: neverStale ? Infinity : 0,
    refetchOnWindowFocus: false,
    ...queryOptions,
  });
};
